import React from "react";
import styled from "styled-components";
import { variant } from "styled-system";
import { Flex } from "../Flex";

interface Props {
  variant?: "primary" | "secondary";
  maxWidth?: string;
}
const ScrollableContainer = styled(Flex)`
  overflow-x: auto;
`;
const Wrapper = styled(Flex)(
  variant({
    variants: {
      primary: {
        bg: "white",
      },
      secondary: {
        bg: "greyLight",
      },
    },
  }),
);

export const PageContentWrapper: React.FC<Props> = ({ children, maxWidth, ...props }) => (
  <Wrapper flexWrap="flex" justifyContent="center" {...props}>
    <ScrollableContainer px={[3, 3, 3, 6, 6]} flexDirection="column" maxWidth={maxWidth} width="100%">
      {children}
    </ScrollableContainer>
  </Wrapper>
);

PageContentWrapper.defaultProps = {
  variant: "primary",
  maxWidth: "1440px",
};
